import InputField from '@/components/form-control/InputField'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

type Props = {}

const schema = yup
  .object({
    current_password: yup.string().required('Current password is required'),
    new_password: yup.string().required('New Password is required'),
    password_confirmation: yup.string().required('Retype password is required'),
  })
  .required()

const ChangePasswordView = (props: Props) => {
  const { t } = useTranslation()
  const inputRefSiteName = useRef<HTMLInputElement>(null)
  const { closeModal } = useConfigUI()

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])

  const form = useForm({
    defaultValues: {
      current_password: '',
      new_password: '',
      password_confirmation: '',
    },
    resolver: yupResolver(schema),
  })

  const handleClick = () => {
    closeModal()
  }

  return (
    <form onSubmit={form.handleSubmit(handleClick)}>
      <Stack
        sx={{
          backgroundColor: 'common.white',
          minWidth: '378px',
          minHeight: '321px',
          padding: '32px 40px',
          boxShadow: '0px 0px 30px rgba(132, 132, 132, 0.25)',
        }}
      >
        <Stack>
          <Typography
            sx={{
              color: '#000000',
              marginBottom: '9px',
            }}
            variant="h3"
          >
            {t('changePassword')}
          </Typography>
          <Box sx={{ marginBottom: '25px' }}>
            <InputField
              name="current_password"
              form={form}
              placeholder="Current Password"
              inputRef={inputRefSiteName}
              style={{
                height: 40,
                borderRadius: '4px',
                width: { xs: '296px' },
              }}
              padding="0px 16px"
            />
          </Box>
          <Box sx={{ marginBottom: '9px' }}>
            <InputField
              name="new_password"
              form={form}
              placeholder={t('NewPassword')}
              style={{
                height: 40,
                borderRadius: '4px',
                width: { xs: '296px' },
              }}
              padding="0px 16px"
            />
          </Box>
          <Box sx={{ marginBottom: '9px' }}>
            <InputField
              name="password_confirmation"
              form={form}
              placeholder={t('RetypePassword')}
              style={{
                height: 40,
                borderRadius: '4px',
                width: { xs: '296px' },
              }}
              padding="0px 16px"
            />
          </Box>
          <Stack
            direction="row"
            sx={{ justifyContent: 'end', marginTop: '30px' }}
          >
            <Button
              color="secondary"
              sx={{
                width: '99px',
                marginRight: '10px',
                maxHeight: '26px',
              }}
              onClick={() => closeModal()}
            >
              <Typography
                sx={{
                  padding: '6px 27px',
                  color: ' primary.main',
                  fontWeight: '500',
                  lineHeight: '14px',
                }}
              >
                {t('commonActionsCancel')}
              </Typography>
            </Button>
            <Button
              color="primary"
              type="submit"
              sx={{ width: '71px', maxHeight: '26px' }}
            >
              <Typography sx={{ padding: '6px 20px' }}>Next</Typography>
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </form>
  )
}

export default ChangePasswordView
